import DevError from '/shared/errors/DevError';

type ConfigWithValidation = {
  reducePage: {
    reductionsConfig: {
      isMinimumReduction: boolean;
      minimumReductionPercentage: number | null;
    };
  };
  step1Answers: {
    allAnswersRequired: boolean;
    minimumAnswersRequired: number | null;
  };
};

function validateConfig<T extends ConfigWithValidation>(config: T): T {
  if (
    config.reducePage.reductionsConfig.isMinimumReduction === true &&
    !(
      config.reducePage.reductionsConfig.minimumReductionPercentage !== null &&
      config.reducePage.reductionsConfig.minimumReductionPercentage >= 1 &&
      config.reducePage.reductionsConfig.minimumReductionPercentage <= 100
    )
  ) {
    throw new DevError(
      'Config Error: If isMinimumReduction is true then minimumReductionPercentage must be a number between 1 - 100',
    );
  }

  if (
    config.reducePage.reductionsConfig.isMinimumReduction === false &&
    config.reducePage.reductionsConfig.minimumReductionPercentage !== null
  ) {
    throw new DevError('Config Error: If isMinimumReduction is false then minimumReductionPercentage must be null');
  }

  if (config.step1Answers.allAnswersRequired === true && config.step1Answers.minimumAnswersRequired !== null) {
    throw new DevError('Config Error: If allAnswersRequired is true then minimumReductionPercentage must be null');
  }

  if (
    config.step1Answers.allAnswersRequired === false &&
    !(config.step1Answers.minimumAnswersRequired !== null && config.step1Answers.minimumAnswersRequired > 0)
  ) {
    throw new DevError(
      'Config Error: If allAnswersRequired is false then minimumReductionPercentage must be a number above 0',
    );
  }

  return config;
}

export default validateConfig;
